var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"c-bcx-progress-dots"},_vm._l((_vm.maxProgress),function(i,index){return _c('li',{key:i,class:_vm.getProgressCookieClass(index),attrs:{"data-iii":i},on:{"click":function($event){return _vm.itemClicked(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }